import { render, staticRenderFns } from "./SettingPromotionProductDashboard.vue?vue&type=template&id=5b63107a&"
import script from "./SettingPromotionProductDashboard.vue?vue&type=script&lang=js&"
export * from "./SettingPromotionProductDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports